import { CheckBox } from "@components/CheckBox";
import { ExclusiveLabel } from "@components/ExclusiveLabel";
import { Row } from "@components/Flex";
import { Body, Title4 } from "@components/Typography";
import { useStyles } from "./styles";
import { SelectionOptionProps } from "./types";

export const SelectionOption = ({
  value,
  onChange,
  title,
  subtitle,
  rightElement,
  style,
  titleStyle,
  exclusiveLabel,
  disabled = false,
}: SelectionOptionProps) => {
  const styles = useStyles();

  const disabledStyle = disabled ? styles.disabled : undefined;

  return (
    <div
      style={{ ...styles.container, ...disabledStyle, ...style }}
      onClick={() => {
        if (!disabled) {
          onChange();
        }
      }}
    >
      <CheckBox value={value} />
      <div style={styles.content}>
        <Row>
          <Title4 style={{ ...styles.title, ...titleStyle }}>{title}</Title4>
          {exclusiveLabel && (
            <ExclusiveLabel style={styles.exclusive}>{exclusiveLabel}</ExclusiveLabel>
          )}
        </Row>
        {subtitle && <Body style={styles.subtitle}>{subtitle}</Body>}
      </div>
      {rightElement}
    </div>
  );
};
